<div class="ea-dash-panel">
  <ng-content select="img"></ng-content>
  <ng-content select="svg-icon-sprite"></ng-content>
  <ng-content></ng-content>
  <ng-content select=".p-footer"></ng-content>
</div>
